export default __webpack_public_path__ + "static/media/image2.70cbc244.jpg";